<template>
  <svg id="icon-link" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-225.5-12.5h554v512h-554z"/>
      <path d="M14.486 10.517a2.4 2.4 0 0 1-2.088 3.58h-2.4a2.4 2.4 0 0 1 0-4.798h.6a.6.6 0 0 0 0-1.2h-.6a3.6 3.6 0 0 0 0 7.198h2.4a3.6 3.6 0 0 0 3.126-5.386l-.006-.012a.601.601 0 1 0-1.032.618zM5.512 9.28A2.4 2.4 0 0 1 7.599 5.7H10a2.4 2.4 0 0 1 0 4.799h-.6a.6.6 0 0 0 0 1.2h.6a3.6 3.6 0 1 0 0-7.199h-2.4a3.6 3.6 0 0 0-3.125 5.387l.006.012a.601.601 0 1 0 1.032-.618z" fill="currentColor" fill-rule="nonzero"/>
    </g>
  </svg>
</template>
